import { useState } from 'react';
import { faqItems } from '@/mocks/faq';

const WA_ESPECIALISTA = "https://wa.me/554891802091?text=Ol%C3%A1%2C%20tenho%20uma%20d%C3%BAvida%20sobre%20m%C3%A1quinas%20de%20solda%20geomembrana.";

const miniStats = [
  { icon: 'ri-shield-check-line', title: '+10 Anos', sub: 'de experiência' },
  { icon: 'ri-global-line', title: '2 Países', sub: 'Brasil & Argentina' },
  { icon: 'ri-tools-line', title: 'Suporte', sub: 'técnico oficial' },
  { icon: 'ri-award-line', title: 'Garantia', sub: 'certificada' },
];

export default function FaqSection() {
  const [openId, setOpenId] = useState<number | null>(
    faqItems.find((f) => f.defaultOpen)?.id ?? null
  );

  const toggle = (id: number) => setOpenId(openId === id ? null : id);

  return (
    <section id="faq" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-12 lg:gap-16">
          <div className="lg:col-span-2">
            <span className="text-green-500 text-xs uppercase tracking-widest mb-3 block">Perguntas Frequentes</span>
            <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-black text-gray-900 uppercase leading-none mb-5">
              TUDO QUE<br />
              <span className="text-green-500">VOCÊ PRECISA</span><br />
              SABER
            </h2>
            <p className="text-gray-500 text-sm leading-relaxed mb-8">
              Respondemos as principais dúvidas sobre máquinas de solda geomembrana, técnicas de soldagem e
              nossos equipamentos. Não encontrou sua resposta?
            </p>
            <a
              href={WA_ESPECIALISTA}
              target="_blank"
              rel="nofollow noreferrer"
              className="inline-flex items-center gap-2 bg-green-500 hover:bg-green-400 text-white font-black text-sm px-6 py-3 rounded-full transition-all cursor-pointer whitespace-nowrap uppercase tracking-wide"
            >
              <i className="ri-whatsapp-line" />
              Falar com Especialista
            </a>

            <div className="mt-10 grid grid-cols-2 gap-3">
              {miniStats.map((s) => (
                <div key={s.title} className="flex items-center gap-2 p-3 bg-gray-50 rounded-xl border border-gray-100">
                  <div className="w-8 h-8 flex items-center justify-center bg-green-100 rounded-lg flex-shrink-0">
                    <i className={`${s.icon} text-green-600 text-sm`} />
                  </div>
                  <div>
                    <p className="text-gray-900 text-xs font-black uppercase">{s.title}</p>
                    <p className="text-gray-400 text-[10px]">{s.sub}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="lg:col-span-3">
            <div className="bg-white rounded-2xl border border-gray-100 px-6 divide-y-0">
              {faqItems.map((item) => (
                <div key={item.id} className="border-b border-gray-100 last:border-0">
                  <button
                    className="w-full flex items-center justify-between gap-4 py-5 text-left cursor-pointer group"
                    aria-expanded={openId === item.id}
                    onClick={() => toggle(item.id)}
                  >
                    <h4 className="text-gray-900 text-sm font-black uppercase leading-snug group-hover:text-green-600 transition-colors">
                      {item.question}
                    </h4>
                    <div
                      className={`w-7 h-7 flex items-center justify-center rounded-full border-2 flex-shrink-0 transition-all duration-300 ${
                        openId === item.id
                          ? 'border-green-500 bg-green-500 text-white rotate-45'
                          : 'border-gray-200 text-gray-400'
                      }`}
                    >
                      <i className="ri-add-line text-sm" />
                    </div>
                  </button>
                  <div
                    className={`overflow-hidden transition-all duration-300 ${
                      openId === item.id ? 'max-h-96 pb-5' : 'max-h-0'
                    }`}
                  >
                    <p className="text-gray-600 text-sm leading-relaxed">{item.answer}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
